import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";
import * as Data from "@/data";

var TaskHelper =
/*#__PURE__*/
function () {
  function TaskHelper() {
    _classCallCheck(this, TaskHelper);

    _defineProperty(this, "STATUSES", {
      NOT_DUE: 0,
      PENDING: 1,
      OVERDUE: 2,
      UNDER_REVIEW: 3,
      REVIEWED: 4,
      APPROVED: 5,
      REJECTED: 6
    });

    _defineProperty(this, "STATUSES_LABELS", ["Not Due", "Pending", "Overdue"]);

    _defineProperty(this, "SCHEDULE", {
      MONTHLY: {
        label: "Monthly",
        value: 0
      },
      QUARTERLY: {
        label: "Quarterly",
        value: 1
      },
      YEARLY: {
        label: "Yearly",
        value: 2
      }
    });

    _defineProperty(this, "TASKS", {
      AFS: {
        label: "AFS",
        value: 1
      },
      BUDGET: {
        label: "Budget",
        value: 2
      },
      OCCUPANCY: {
        label: "Occupancy",
        value: 3
      },
      UTILITY_ALLOWANCE: {
        label: "Utility Allowance",
        value: 4
      },
      TCAP: {
        label: "TCAP",
        value: 5
      },
      EXHIBIT: {
        label: "Exhibit",
        value: 6
      },
      EXHIBITZ: {
        label: "Exhibit Z",
        value: 7
      }
    });
  }

  _createClass(TaskHelper, [{
    key: "GoToListForTask",
    value: function GoToListForTask(task, propertyId) {
      var route = null;

      switch (task) {
        case "Occupancy":
          route = "occupancy/list/project";
          break;

        case "Utility Allowance":
          route = "utilityAllowance/list/project";
          break;

        case "Budget":
          route = "budget/list/project";
          break;

        case "TCAP":
          route = "TCAPList";
          break;

        case "Rent Increase":
          return "rentIncrease/RentIncreaseMultiNav";

        case "AFS":
          route = "afs/list/single";
          break;

        case "Exhibit Z":
          route = "HousingPriorityCertificationList";
          break;
      }

      return "/".concat(route, "/").concat(propertyId);
    }
  }, {
    key: "GetScheduleLabel",
    value: function GetScheduleLabel(id) {
      if (id == this.SCHEDULE.MONTHLY.value) return this.SCHEDULE.MONTHLY.label;else if (id == this.SCHEDULE.QUARTERLY.value) return this.SCHEDULE.QUARTERLY.label;else if (id == this.SCHEDULE.YEARLY.value) return this.SCHEDULE.YEARLY.label;
      return "";
    }
  }, {
    key: "GetPeriodDate",
    value: function GetPeriodDate(schedule, year, month, quarter) {
      if (year == null) return null;
      if (schedule == this.SCHEDULE.QUARTERLY.value) return new Date(year, quarter ? (quarter - 1) * 3 : 1, 1);
      return new Date(year, month ? month - 1 : 0, 1);
    }
  }, {
    key: "GetStartPeriodDate",
    value: function GetStartPeriodDate(schedule, settings) {
      var activityPeriod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.GetPeriodDate(schedule, settings.startYear, activityPeriod ? activityPeriod.startMonth : settings.startMonth, settings.startQuarterQuarterId);
    }
  }, {
    key: "GetEndPeriodDate",
    value: function GetEndPeriodDate(schedule, settings) {
      return this.GetPeriodDate(schedule, settings.endYear, settings.endMonth, settings.endQuarterQuarterId);
    }
  }, {
    key: "HasInvalidRange",
    value: function HasInvalidRange(setting, schedule) {
      if (setting.endYear == null || setting.startYear < setting.endYear) return false;else if (setting.startYear > setting.endYear) return true;else if (schedule == this.SCHEDULE.MONTHLY.value) return setting.startMonth > setting.endMonth;else if (schedule == this.SCHEDULE.QUARTERLY.value) return setting.startQuarterQuarterId > setting.endQuarterQuarterId;else return false;
    }
  }]);

  return TaskHelper;
}();

export default new TaskHelper();